import moment from 'moment';

// Format UTC or server date strings to local browser time.
// Strings without 'Z' or a timezone offset are treated as UTC.
export const formatLocalTime = (dateInput, formatPattern = 'DD-MMM-YYYY hh:mm A') => {
  if (!dateInput) return '-';

  let formattedInput = dateInput;
  if (typeof dateInput === 'string' && !dateInput.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(dateInput)) {
    formattedInput = `${dateInput}Z`;
  }

  return moment.utc(formattedInput).local().format(formatPattern);
};

// Parse a UTC/server date string into a Date (for sorting/comparison)
export const parseUtc = (dateInput) => moment.utc(
  typeof dateInput === 'string' && !dateInput.endsWith('Z') && !/[+-]\d{2}:\d{2}$/.test(dateInput)
    ? `${dateInput}Z`
    : dateInput
).toDate();
